import React from "react";
import "./styles.scss";
import imagenLogin from "./../../../resources/splash.jpg";
import { Services } from "./Services";
import axios from "axios";
import Authentication from "../../../../src/services/Authentication.js";
import { withRouter } from "react-router-dom";
import {
  Label,
  Input,
  Row,
  Col,
  CardBody,
  FormGroup,
  Button,
  Container,
  Form,
} from "reactstrap";
import Log from "./MagicVision_White.png";

const auth = new Authentication();
const BackgroundHead = {
  height: "100%",
  backgroundImage: "url(" + imagenLogin + ")",
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: "calc(100vw + 48px)",
};
/*=============================================
=            Login Component                  =
=============================================*/
function Login(props) {
  const [redirectlogin, setRedirectlogin] = React.useState({
    login: {
      email: localStorage.getItem("email") ? localStorage.getItem("email") : "",
      valid: false,
      password: localStorage.getItem("password")
        ? localStorage.getItem("password")
        : "",
      check: localStorage.getItem("email") ? true : false,
    },
  });
  let [password, setPassword] = React.useState(false);
  const [recoverPassword, setrecoverPassword] = React.useState("");
  const [response, setresponse] = React.useState("");

  // const [redirectToken, setRedirectToken] = React.useState('');
  // const [redirectUserData, setRedirectUserData] = React.useState('');
  // const [redirectUserFlat, setRedirectUserFlat] = React.useState(false);
  // const [redirectUserCustomers, setRedirectUserCustomers] = React.useState('');
  // const [redirectUsercustomerSelect, setRedirectUsercustomerSelect] = React.useState([]);

  /*=============================================
  =            Handle Login Function            =
  =============================================*/
  function change(event) {
    document.getElementById("email_sin").setAttribute("hidden", "hidden");
    document.getElementById("pass_sin").setAttribute("hidden", "hidden");
    document.getElementById("error_user").setAttribute("hidden", "hidden");
    if (event.target.name === "email") {
      let value = event.target.value;
      const emailRegex = new RegExp(/^\S+@\S+\.\S+$/);
      if (emailRegex.test(value)) {
        redirectlogin.login.valid = true;
        document.getElementById("input_email");
        document.getElementById("email_alert").setAttribute("hidden", "hidden");
      } else {
        redirectlogin.login.valid = false;
        document.getElementById("input_email");
        document.getElementById("email_alert").removeAttribute("hidden");
      }
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    } else {
      let value = event.target.value;
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
  }

  function changeCorreo(event) {
    document.getElementById("correo_alert").removeAttribute("hidden");
    document
      .getElementById("correo_alert_base")
      .setAttribute("hidden", "hidden");
    document.getElementById("correo_sin").setAttribute("hidden", "hidden");
    let value = event.target.value;
    const emailRegex = new RegExp(/^\S+@\S+\.\S+$/);
    if (emailRegex.test(value)) {
      // document.getElementById('input_correo').className = 'input100';
      document.getElementById("correo_alert").setAttribute("hidden", "hidden");
      document.getElementById("correo_aler_button").removeAttribute("hidden");
    } else {
      // document.getElementById('input_correo').className = 'invalidInput';
      document.getElementById("correo_alert").removeAttribute("hidden");
      document
        .getElementById("correo_aler_button")
        .setAttribute("hidden", "hidden");
    }
    setrecoverPassword(value);
  }

  // function validateOnChange(event){
  //   if (event && event.value) {
  //     let id = event.value;
  //     setRedirectUserCustomers(id);
  //     auth.setAuthentication(redirectToken,redirectUserData.redirectUserData,id);
  //     props.history.push('/dashboard');
  //   }
  //   else {
  //     let id = '';
  //     setRedirectUserCustomers(id);
  //   }
  // }

  function handleLoginId() {
    if (!redirectlogin.login.email) {
      document.getElementById("email_sin").removeAttribute("hidden");
    } else if (!redirectlogin.login.password) {
      document.getElementById("pass_sin").removeAttribute("hidden");
    } else {
      document.getElementById("email_sin").setAttribute("hidden", "hidden");
      document.getElementById("pass_sin").setAttribute("hidden", "hidden");
      let data = {
        email: redirectlogin.login.email,
        password: redirectlogin.login.password,
      };
      axios
        .post(`${Services.PostOauth.path}oauth/setAuthentication`, data)
        .then((response) => {
          let token = response.data.token;
          let redirectUserData = response.data.data;
          if (redirectlogin.login.check) {
            localStorage.setItem("email", redirectlogin.login.email);
            localStorage.setItem("password", redirectlogin.login.password);
          }
          // setRedirectToken(response.data.token);
          // setRedirectUserData({redirectUserData});
          let id = response.data.data[0].UserId;
          axios
            .get(
              `${Services.GetCustomerForUserId.path}admin/customerForId/${id}`,
              {}
            )
            .then((response) => {
              // if (response.data.resp.length === 1){
              //   let redirectUserFlat = false;
              //   setRedirectUserFlat(redirectUserFlat);
              // }
              // let data = [];
              // response.data.resp.forEach((e) => {
              //   data.push({ value: e.ClienteId, label: e.Nombre });
              // });
              // if (data.length === 1){

              let groupData = [];
              // let firstTrue = true;
              response.data.resp.map((e) => {
                let findGroup = false;
                groupData.map((f) => {
                  if (e.GroupId === f.id) {
                    findGroup = true;
                    let cliente = {
                      id: e.CustomerId,
                      value: e.Name,
                      NIT: e.RFC, //no viene en la data
                      hidden: false,
                      check: true,
                    };
                    f.data.push(cliente);
                  }
                  return f;
                });
                if (!findGroup) {
                  let grupo = {
                    id: e.GroupId,
                    sort: e.GroupId ? "a" : "z",
                    value: e.Group ? e.Group : "No Group",
                    check: true,
                    hidden: false,
                    data: [
                      {
                        id: e.CustomerId,
                        value: e.Name,
                        NIT: e.RFC, //no viene en la data
                        hidden: false,
                        // check: firstTrue ? true : false,
                        check: true,
                      },
                    ],
                  };
                  // firstTrue = false;
                  groupData.push(grupo);
                }
                return e;
              });
              groupData.sort((a, b) => a.sort.localeCompare(b.sort));
              // let customer = data;
              // setRedirectUserCustomers(customer);
              auth.setAuthentication(token, redirectUserData, groupData);
              props.history.push("/Home");
              // }
              // else{
              // setRedirectUserFlat(!redirectUserFlat);
              // setRedirectUsercustomerSelect(data);
              // }
              const createOffsetValue = (date) => {
                let sign = date.getTimezoneOffset() > 0 ? '-' : '+';
                let offset = Math.abs(date.getTimezoneOffset());
                let hours = Math.floor(offset / 60);
                let minutes = ((offset % 60) / 60) * 10;
                return sign + hours + '.' + minutes;
              };
              let userAudit = {
                UsuarioId: id,
                SessionId: token,
                StartConnection: new Date(),
                timezone: createOffsetValue(new Date()),
                Origin: 'web',
              };

              console.log("userAudit", userAudit);

              navigator.sendBeacon(`${Services.AUDIT.path}user/login`, JSON.stringify(userAudit))
              // navigator.sendBeacon(
              //   'https://roldanapiaudit.azurewebsites.net/user/login',
              //   JSON.stringify(userAudit)
              // );

            })
            .catch((error) => {
              console.warn(error);
            });
        })

        .catch((error) => {
          document.getElementById("error_user").removeAttribute("hidden");
        });
    }
  }

  function handleAccount() {
    if (!recoverPassword) {
      document.getElementById("correo_sin").removeAttribute("hidden");
    } else {
      document.getElementById("correo_sin").setAttribute("hidden", "hidden");
      let data = {
        correo: recoverPassword,
      };
      axios
        .post(`${Services.Post_Data_Recovery.path}admin/recover`, data)
        .then((response) => {
          document.getElementById("correo_exitoso").removeAttribute("hidden");
          setrecoverPassword("");
        })
        .catch((error) => {
          if (error.response) {
            setresponse(error.response.data.message);
            document
              .getElementById("correo_alert_base")
              .removeAttribute("hidden");
            console.log("error", error.response.data.message);
          }
        });
    }
  }

  function funtionRegresa() {
    setPassword(!password);
    setrecoverPassword("");
    // document.getElementById('input_email').className = 'input100';
    document.getElementById("input_correo").className = "input100";
    document.getElementById("correo_sin").setAttribute("hidden", "hidden");
    document.getElementById("correo_alert").setAttribute("hidden", "hidden");
    document
      .getElementById("correo_alert_base")
      .setAttribute("hidden", "hidden");
    document
      .getElementById("correo_aler_button")
      .setAttribute("hidden", "hidden");
    document.getElementById("correo_exitoso").setAttribute("hidden", "hidden");

    // document.getElementById('error_user').setAttribute('hidden', 'hidden');
  }

  if (redirectlogin.login.check) {
    localStorage.setItem("email", redirectlogin.login.email);
    localStorage.setItem("password", redirectlogin.login.password);
  } else {
    localStorage.removeItem("email", "email");
    localStorage.removeItem("password", "password");
  }

  return (
    <div style={BackgroundHead}>
      <div className="container-login100">
        {!password ? (
          <Container>
            <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
              <Form>
                <CardBody style={{ textAlign: "center" }}>
                  <div className="logo-container">
                    <img
                      style={{ width: "100%" }}
                      src={Log}
                      alt="now-logo"
                    ></img>
                  </div>
                </CardBody>
                <br></br>
                <CardBody>
                  <FormGroup>
                    <Input
                      type="text"
                      id="input_email"
                      name="email"
                      placeholder="Users..."
                      onChange={change}
                      value={redirectlogin.login.email}
                      defaultValue="Error input"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="password"
                      value={redirectlogin.login.password}
                      name="password"
                      onChange={change}
                      placeholder="Password..."
                    />
                    <div
                      style={{
                        color: "white",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                      className="_alert"
                      id="email_alert"
                      hidden
                    >
                      Enter a valid email
                    </div>
                    <div
                      style={{
                        color: "white",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                      className="_alert"
                      id="email_sin"
                      hidden
                    >
                      Email is required
                    </div>
                    <div
                      style={{
                        color: "white",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                      className="_alert"
                      id="pass_sin"
                      hidden
                    >
                      Password is required
                    </div>
                    <div
                      style={{
                        color: "white",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                      className="_alert"
                      id="error_user"
                      hidden
                    >
                      The password and / or email are incorrect
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <Row className="justify-content-md-center">
                      <Label style={{ color: "white" }}>
                        <Input
                          type="checkbox"
                          onChange={() => {
                            redirectlogin.login.check =
                              !redirectlogin.login.check;
                            setRedirectlogin({
                              redirectlogin,
                              ...redirectlogin,
                            });
                          }}
                          checked={redirectlogin.login.check}
                        />
                        Remember password
                      </Label>
                    </Row>
                  </FormGroup>
                  <Button
                    color="success"
                    block
                    onClick={handleLoginId}
                  >
                    LogIn
                  </Button>
                  <div style={{ height: 10 }}></div>
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <Label
                      style={{ color: "white", cursor: "pointer" }}
                      onClick={() => {
                        setPassword(!password);
                      }}
                    >
                      Forgot your password?
                    </Label>
                  </div>
                </CardBody>
              </Form>
            </Col>
            <Col md={12} style={{ textAlign: "center", paddingTop: 100 }}>
              <em>
                {" "}
                <img
                  alt="apple_store"
                  src="https://fsposeidon.blob.core.windows.net/general/app_store_image.jpg"
                  className="apple_image"
                ></img>{" "}
              </em>
              <em>
                {" "}
                <img
                  alt="play_store"
                  src="https://fsposeidon.blob.core.windows.net/general/android_download.png"
                  className="android_image"
                ></img>{" "}
              </em>
              <div className="_copy_rigth">
                Copyright © {new Date().getFullYear()}{" "}
                <a href="https://www.interglobo.com/" className="link-terms">
                  Interglobo
                </a>.{" "}All rights reserved.
              </div>
              <div className="_copy_rigth">
                <a
                  target="_blank"
                  href={Services.URL.path + "terminos-y-condiciones"}
                  className="link-terms"
                >
                  {" "}
                  Terms and Conditions
                </a>{" "}and{" "}
                <a
                  target="_blank"
                  href={Services.URL.path + "aviso-de-privacidad"}
                  className="link-terms"
                >
                  Privacy Policy
                </a>
              </div>
            </Col>
          </Container>
        ) : (
          <div
            className="wrap-login100 p-t-0 p-b-0"
            style={{ background: "transparent" }}
          >
            <div>
              <div className="col-12">
                <label
                  style={{
                    color: "white",
                    fontSize: "28px",
                    textAlignLast: "center",
                  }}
                >
                  Recover password
                </label>
              </div>
              <div className="col-12" style={{ height: 10 }}></div>
              <div className="col-12">
                <label
                  style={{
                    color: "white",
                    fontSize: "15px",
                    textAlignLast: "center",
                  }}
                >
                  Enter your email address with which you registered for the
                  first time and send the confirmation email to your account.
                </label>
              </div>
            </div>
            <div style={{ height: 10 }} />
            {/* {redirectUserFlat ? <></> : <> */}
            <div className="col-12" style={{ textAlign: "center" }}>
              <div
                className="wrap-input100 validate-input m-b-12 "
                data-validate="Correo es requerio"
              >
                {/* <input className="input100" id="input_correo" type="text" value={recoverPassword} name="correo" onChange={changeCorreo} placeholder="Correo a recuperar contraseña" /> */}
                <Input
                  type="text"
                  id="input_correo"
                  name="correo"
                  placeholder="Mail to recover password"
                  onChange={changeCorreo}
                  value={recoverPassword}
                // defaultValue="Error input"
                />
                <span className="focus-input100"></span>
              </div>
              <div style={{ height: 10 }} />
              {/* <div style={{padding:'3px',marginTop:'-14px', color:'#BA2B30', fontSize:'12px'}} className="_alert" id="correo_alert_recuperar" hidden>Introduce una dirección de correo electrónico válida</div> */}
              <div
                style={{
                  padding: "3px",
                  marginTop: "-14px",
                  color: "white",
                  fontSize: "14px",
                }}
                className="_alert"
                id="correo_alert"
                hidden
              >
                Please enter a valid email
              </div>
              <div
                style={{
                  padding: "3px",
                  marginTop: "-14px",
                  color: "white",
                  fontSize: "14px",
                }}
                className="_alert"
                id="correo_alert_base"
                hidden
              >
                {response}
              </div>
              <div
                style={{
                  padding: "3px",
                  marginTop: "-14px",
                  color: "white",
                  fontSize: "14px",
                }}
                className="_alert"
                id="correo_sin"
                hidden
              >
                Email is Required
              </div>
              <div
                style={{
                  padding: "3px",
                  marginTop: "-14px",
                  color: "white",
                  fontSize: "14px",
                }}
                className="_alert"
                id="error_correo"
                hidden
              >
                unregistered email
              </div>
              <div
                style={{
                  padding: "3px",
                  marginTop: "-14px",
                  color: "white",
                  fontSize: "14px",
                }}
                className="_alert"
                id="correo_exitoso"
                hidden
              >
                Email successfully sent
              </div>
            </div>
            <div style={{ height: 30 }} />
            <div className="container-login100-form-btn">
              <div className="col-6" style={{ marginTop: "-1px" }}>
                <Button
                  color="success"
                  block
                  onClick={funtionRegresa}
                >
                  Back
                </Button>
              </div>
              <div className="col-6" style={{ textAlign: "-webkit-right" }}>
                <Button
                  color="success"
                  block
                  id="correo_aler_button"
                  onClick={handleAccount}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div >
  );
}
export default withRouter(Login);
